import React, { useState, useEffect } from 'react';
import Spinner from '../components/ui/Spinner';

const months = [
  { value: '01', label: 'January' },
  { value: '02', label: 'February' },
  { value: '03', label: 'March' },
  { value: '04', label: 'April' },
  { value: '05', label: 'May' },
  { value: '06', label: 'June' },
  { value: '07', label: 'July' },
  { value: '08', label: 'August' },
  { value: '09', label: 'September' },
  { value: '10', label: 'October' },
  { value: '11', label: 'November' },
  { value: '12', label: 'December' }
];

const FilterDropdown = ({ onFilterChange, loading }) => {
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  
  const currentYear = new Date().getFullYear();
  // Generates years from 2024 onwards based on your logic
  const years = Array.from({ length: currentYear - 2023 }, (_, i) => currentYear - i);

  useEffect(() => {
    // Set default values to current month and year
    const currentDate = new Date();
    setSelectedMonth(String(currentDate.getMonth() + 1).padStart(2, '0'));
    setSelectedYear(String(currentDate.getFullYear()));
  }, []);

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const handleFilter = () => {
    if (selectedMonth && selectedYear) {
      const startDate = `${selectedYear}-${selectedMonth}-01`;
      const endDate = new Date(selectedYear, selectedMonth, 0).toISOString().split('T')[0];
      onFilterChange(startDate, endDate);
    }
  };

  // Shared Styles for Select Inputs
  const selectStyle = "block w-full rounded-xl border border-zinc-300 bg-white px-4 py-3 text-sm font-medium text-zinc-900 transition-colors focus:border-zinc-900 focus:outline-none focus:ring-2 focus:ring-zinc-300 dark:border-zinc-700 dark:bg-black dark:text-white dark:focus:border-white dark:focus:ring-zinc-800";

  return (
    <div className="flex w-full flex-col items-stretch gap-3 md:flex-row md:items-center md:justify-end">
      
      {/* Month Selector */}
      <div className="w-full md:w-44">
        <select
          className={selectStyle}
          value={selectedMonth}
          onChange={handleMonthChange}
        >
          {months.map((month) => (
            <option key={month.value} value={month.value}>
              {month.label}
            </option>
          ))}
        </select>
      </div>

      {/* Year Selector */}
      <div className="w-full md:w-32">
        <select
          className={selectStyle}
          value={selectedYear}
          onChange={handleYearChange}
        >
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>

      {/* Apply Button */}
      <div className="w-full md:w-auto">
        <button
          onClick={handleFilter}
          disabled={loading}
          className={`flex w-full items-center justify-center gap-2 rounded-xl bg-zinc-900 px-5 py-3 text-sm font-semibold text-white transition-all focus:outline-none focus:ring-2 focus:ring-zinc-300 hover:bg-zinc-800 dark:bg-white dark:text-black dark:hover:bg-zinc-200 dark:focus:ring-zinc-700 md:w-auto ${
            loading ? 'opacity-70 cursor-not-allowed' : ''
          }`}
        >
          {loading ? (
            <>
              {/* You can use your Spinner component here, or a simple Tailwind SVG spinner */}
               <Spinner animation="border" size="sm" className="w-4 h-4 text-current" />
               <span>Loading...</span>
            </>
          ) : (
            <>
              <i className="fas fa-filter text-xs"></i>
              <span>Apply Filter</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default FilterDropdown;
